import { z } from 'zod'

export const MessageSchema = z.object({
  id: z.number(),
  message: z.string(),
  created_datetime: z.string(),
  user_id: z.number().nullable(),
  applicant_id: z.number().nullable(),
})

export const MessagesSchema = z.array(MessageSchema)

export type Message = z.infer<typeof MessageSchema>
